import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import SkeletonCardLoad from "../../../components/SkeletonCardLoad";
import { CountryTable, EntryMode, PutCountryTable, PutCrossCountryEntry } from "../../../models/Admin/CountryTables";
import msalRestClient from "../../../services/clients/MsalRestClient";
import CountryTableEntry from "./CountryTableEntry";

const CountryTableEdit = () => {

    // #region Init States

    let initTable: PutCountryTable = {
        id           : -1,
        name         : '',
        description  : '',
        countrySet   : []
    }

    // #endregion

    // #region Status & Hooks

    const { id } = useParams();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [table, setTable] = useState<PutCountryTable>(initTable);
    const [errors, setErrors] = useState<String[]>([]);

    const navigate = useNavigate();

    // #endregion

    useEffect(() => { fetchFromApi(); }, [])

    /**
     * TBD ...
     */
    const fetchFromApi = () => {

        setIsLoading(true);

        msalRestClient.get<CountryTable>("/api/countrytables/" + id)
            .then(response => {
                if (response.status === 200) {
                    setTable({
                        id          : response.data.id,
                        description : response.data.description,
                        name        : response.data.name,
                        countrySet  : response.data.countrySet.map(x => ({ id: x.id, sourceCountryId: x.sourceCountryId, targetCountryId: x.targetCountryId, refundRate: x.refundRate, mode: EntryMode.Display }))
                    })
                }
            })
            .finally(() => { setIsLoading(false); })
    }

    /**
     * Renders error Pane that display a list of error to user.
     * @returns
     */
    const renderErrorPane = () => {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="alert alert-danger">
                        <p className="fw-bold mb-0">Whoops! There were some problems with your input.</p>
                        <ul className="mb-0">
                            {
                                errors.map((value, index) => {
                                    return (
                                        <li key={"err_" + index}>{value}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * TBD ...
     * @param entry
     * @param index
     */
    const onSubmitEntry = (entry: PutCrossCountryEntry, index: number) => {

        let countrySets = table.countrySet.map((item, i) => (i === index ? entry : item));
        setTable(x => ({ ...x, countrySet: countrySets }));
    }

    /**
     * TBD ...
     * @param index
     */
    const onDeleteEntry = (index: number) => {

        let countrySet = table.countrySet.filter((x, i) => i !== index);
        setTable(x => ({ ...x, countrySet: countrySet }));
    }

    /**
     * Callback function called by clicking the "Create New" Button
     */
    const onNewEntryClick = () => {
        let newEntry: PutCrossCountryEntry = {
            id              : 0,
            sourceCountryId : 0,
            targetCountryId : 0,
            refundRate      : 0,
            mode            : EntryMode.Create
        }
        setTable(x => ({ ...x, countrySet: [...x.countrySet, newEntry] }));
    }

    /**
     * TBD ...
     */
    async function onSubmit(): Promise<void> {

        msalRestClient.put<CountryTable>("/api/countrytables", table)
            .then(response => {
                if (response.status === 200) { navigate("/admin/countries"); }
            })
            .catch((err: AxiosError) => {
                if (err.response!.status === 422) {
                    if (err.response?.data && (err.response.data as string)) {
                        setErrors([err.response.data as string]);
                    }
                }
            })
    }

    return (
        <main className="container mb-4">

            <div className="row mb-2">
                <div className="col-12 text-end">
                    <NavLink to="/admin/countries" className="btn btn-danger">
                        <i className="bi bi-x-lg" />
                    </NavLink>
                </div>
            </div>

            <div className="row">
                <div className="col-12">

                    <div className="card">
                        <div className="card-body">
                            {
                                isLoading ? <SkeletonCardLoad cardsCount={1} />
                                    :
                                    <>
                                        {(errors.length > 0) && renderErrorPane()}

                                        <div className="form-group col-md-12">
                                            <label className="fw-bold" htmlFor="tableName">Tablename</label>
                                            <input type="text" className="form-control" id="tableName" name="tableName" value={table.name} onChange={e => setTable(x => ({ ...x, name: e.target.value }))} />
                                        </div>

                                        <div className="form-group col-md-12">
                                            <label className="fw-bold" htmlFor="description">Description</label>
                                            <textarea cols={1} rows={5} value={table.description} className="form-control" id="description" name="description" onChange={e => setTable(x => ({ ...x, description: e.target.value }))} />
                                        </div>

                                        <div className="col-md-12">

                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th colSpan={4}>
                                                            <button className="btn btn-success" onClick={e => onNewEntryClick()}>
                                                                <i className="bi bi-plus-lg me-1" />Add new Country Pair
                                                            </button>
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th>Origin Country</th>
                                                        <th>Destination Country</th>
                                                        <th>Refund</th>
                                                        <th>
                                                            { /* Empty for controls */ }
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        table.countrySet.map((value, index) => {
                                                            return <CountryTableEntry index={index} value={value} onConfirm={onSubmitEntry} onDelete={onDeleteEntry} />
                                                        })
                                                    }
                                                </tbody>
                                            </table>    

                                        </div>

                                    </>
                            }
                        </div>
                        <div className="card-footer text-end">
                            <button className="btn btn-success" onClick={onSubmit}><i className="bi bi-check-lg me-1"></i>Validate and Create</button>
                        </div>

                    </div>

                </div>
            </div>

        </main>
    )
}
export default CountryTableEdit;
